/* unplugin-vue-components disabled */import script from "./TeamOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamOrder.vue?vue&type=script&setup=true&lang=js"

import "./TeamOrder.vue?vue&type=style&index=0&id=eb8d8fa0&lang=css"

const __exports__ = script;

export default __exports__